import { ReactNode } from "react";

interface SpinnerProps {
    color?: string; 
    size?: number;
    className?: string;
}

interface SVGProps extends React.SVGProps<SVGSVGElement> {
    size?: number | string;
    color?: string;
    className?: string;
}

interface CloseIconProps {
    className?: string;
}

interface ArrowUpAndDown {
    isOpen: boolean;
}

interface CheckedProps {
    className?: string
}

export const Spinner = ({ color = "#fcfcfc", size = 64 }: SpinnerProps ) => (
    <svg className="animate-spin" width={size} height={size} viewBox="0 0 24 24" >
        <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="4" strokeOpacity="0.3" fill="none" />
        <path d="M22 12a10 10 0 0 1-10 10" stroke={color} strokeWidth="4" strokeLinecap="round" fill="none" />
    </svg>
);

export const CloseIcon = ({ className }: CloseIconProps) => {
    return (
        <svg className={`w-4 h-4 ${className || ""}`} viewBox="0 0 20 20" fill="currentColor" >
            <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
        </svg>
    );
};

export const ArrowUpAndDown = ({ isOpen }: ArrowUpAndDown) => {
    return (
        <svg className={`w-4 h-4 ml-2 transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`} viewBox="0 0 20 20" fill="currentColor" >
            <path d="M5 8l5 5 5-5H5z" />
        </svg>
    )
}

export const UserAccount = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="w-7 h-7 text-gray-700" >
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
        </svg>
    )
}

export const Checked = ({className = "w-3 h-3 text-white" }: CheckedProps) => {
    return (
        <svg className={className} fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24" >
            <path d="M5 13l4 4L19 7" />
        </svg>
    )
}

export const ArrowUp = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-3 h-3 text-gray-400" >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 15l7-7 7 7" />
        </svg>
    )
}

export const ArrowDown = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-3 h-3 text-gray-400" >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
        </svg>
    )
}

export const MaintenanceOne = () => {
    return (
        <svg viewBox="0 0 24 24" className="w-full h-full text-[#186cb2]" fill="none">
            <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
            <path d="M12 7v5l3 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    )
}

export const MaintenanceTwo = () => {
    return (
        <svg viewBox="0 0 24 24" className="w-full h-full text-[#186cb2]" fill="none">
            <path d="M3 21h18" stroke="currentColor" strokeWidth="1.5" />
            <path d="M7 21V10l5-4 5 4v11" stroke="currentColor" strokeWidth="1.5" />
            <path d="M9 21v-6h6v6" stroke="currentColor" strokeWidth="1.5" />
            <path d="M14 4l6 6" stroke="currentColor" strokeWidth="1.5" />
            <path d="M20 4l-6 6" stroke="currentColor" strokeWidth="1.5" />
        </svg>
    )
}

export const MaintenanceThree = () => {
    return (
        <svg viewBox="0 0 24 24" className="w-full h-full text-[#186cb2]" fill="none">
            <path d="M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z" stroke="currentColor" strokeWidth="1.5" />
            <path d="M19.4 15a7.8 7.8 0 0 0 .1-2l2-1.2-2-3.4-2.3.6a7.3 7.3 0 0 0-1.7-1l-.3-2.4h-4l-.3 2.4a7.3 7.3 0 0 0-1.7 1l-2.3-.6-2 3.4 2 1.2a7.8 7.8 0 0 0 .1 2l-2 1.2 2 3.4 2.3-.6c.5.4 1.1.7 1.7 1l.3 2.4h4l.3-2.4c.6-.3 1.2-.6 1.7-1l2.3.6 2-3.4-2-1.2Z" stroke="currentColor" strokeWidth="1.2" />
        </svg>
    )
}

export const MaintenanceFour = () => {
    return (
        <svg viewBox="0 0 24 24" fill="none" className="w-full h-full text-[#186cb2]" >
            <path d="M12 2L2 7l10 5 10-5-10-5z" fill="currentColor" opacity="0.3" />
            <path d="M2 17l10 5 10-5" stroke="currentColor" strokeWidth="2" />
            <path d="M2 12l10 5 10-5" stroke="currentColor" strokeWidth="2" opacity="0.7" />
        </svg>
    )
}

export const CheckedGreen = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} >
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
        </svg>
    )
}

export const UploadIconSVG = ({size = 40, color = "#186cb2", className = "", ...props}: SVGProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={1.8} className={className} {...props}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 16V4m0 0-4 4m4-4 4 4M5 16v2a2 2 0 002 2h10a2 2 0 002-2v-2" />
        </svg>
    )
}

export const FileIconSVG = ({size = 30, color = "#186cb2", className = "", ...props}: SVGProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={1.8} className={className} {...props}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M7 3h7l5 5v13H7a2 2 0 01-2-2V5a2 2 0 012-2z" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M14 3v5h5" />
        </svg>
    )
}

export const DeleteFileIconSVG = ({size = 30, color = "#ef4444", className = "", ...props}: SVGProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={1.8} className={className} {...props}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M19 7H5m3 0V5a1 1 0 011-1h6a1 1 0 011 1v2m-8 0v11a2 2 0 002 2h4a2 2 0 002-2V7" />
        </svg>
    )
}

export const AddFileIconSVG = ({size = 30, color = "#186cb2", className = "", ...props}: SVGProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={1.8} className={className} {...props}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 5v14m-7-7h14" />
        </svg>
    )
}


export const PDFIconSVG = ({size = 20, ...props}: SVGProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
            <path d="M7 2h7l5 5v13a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z" fill="#DC2626"/>
            <path d="M14 2v5h5" fill="#FCA5A5"/>
            <text x="12" y="17" text-anchor="middle" font-size="5" fontWeight="700" fill="#fff">PDF</text>
        </svg>
    )
}

export const CSVIconSVG = ({size = 20, ...props}: SVGProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
            <path d="M7 2h7l5 5v13a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z" fill="#16A34A"/>
            <path d="M14 2v5h5" fill="#86EFAC"/>
            <text x="12" y="17" text-anchor="middle" font-size="5" fontWeight="700" fill="#fff">CSV</text>
        </svg>
    )
}

export const ExcelIconSVG = ({size = 20, ...props}: SVGProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
            <path d="M7 2h7l5 5v13a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z" fill="#15803D"/>
            <path d="M14 2v5h5" fill="#BBF7D0"/>
            <text x="12" y="17" text-anchor="middle" font-size="4.5" fontWeight="700" fill="#fff">XLS</text>
        </svg>
    )
}

export const ImageIconSVG = ({size = 20, ...props}: SVGProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
            <path d="M7 2h7l5 5v13a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z" fill="#7C3AED"/>
            <path d="M14 2v5h5" fill="#DDD6FE"/>
            <circle cx="10" cy="10" r="1.5" fill="#fff"/>
            <path d="M8 17l3-3 2 2 2-3 2 4H8z" fill="#fff"/>
        </svg>
    )
}

export const DocumentIconSVG = ({size = 20, ...props}: SVGProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
            <path d="M7 2h7l5 5v13a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z" fill="#2563EB"/>
            <path d="M14 2v5h5" fill="#BFDBFE"/>
            <path d="M9 11h6M9 14h6M9 17h4" stroke="#fff" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
    )
}

export const EditSVG = ({size = 20, className = 'h-4 w-4', color = 'currentColor'}: SVGProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" className={className} fill="none" viewBox="0 0 24 24" stroke={color} >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M16.862 3.487a2.25 2.25 0 113.182 3.182L7.5 19.213l-4 1 1-4L16.862 3.487z" />
        </svg>
    )
}

export const CheckSVG = ({size = 20, className = 'h-4 w-4', color = 'currentColor'}: SVGProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" className={className} fill="none" viewBox="0 0 24 24" stroke={color} >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
    )
}

export const WarningSVG = ({size = 20, className = '', color = 'currentColor'}: SVGProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v3.75m0 3.75h.008M10.29 3.86l-8.82 15a1.5 1.5 0 001.3 2.25h18.46a1.5 1.5 0 001.3-2.25l-8.82-15a1.5 1.5 0 00-2.59 0z" />
        </svg>
    )
}

export const NoteSVG = ({size = 20, className = '', color = 'currentColor'}: SVGProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M12 22a10 10 0 100-20 10 10 0 000 20z" />
        </svg>
    )
}

export const ArrowSVG = ({size = 20, className = '', color = 'currentColor'}: SVGProps) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
    )
}

export const ProposalCompute = ({ color = '#186cb2', size = 18 }: { color?: string; size?: number }) => (
    <svg className="shrink-0" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="4" y="2.5" width="16" height="19" rx="2" />
        <path d="M8 6h8" />
        <path d="M8 10h.01M12 10h.01M16 10h.01" />
        <path d="M8 14h.01M12 14h.01M16 14h.01" />
        <path d="M8 18h.01M12 18h4" />
    </svg>
);

export const ProposalRelease = ({ color = '#186cb2', size = 18 }: { color?: string; size?: number }) => (
    <svg className="shrink-0" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M5 12h13" />
        <path d="m13 6 6 6-6 6" />
        <path d="M5 6v12" />
    </svg>
);

export const ProposalEdit = ({ color = '#186cb2', size = 18 }: { color?: string; size?: number }) => (
    <svg className="shrink-0" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 20h9" />
        <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L8 18l-4 1 1-4Z" />
    </svg>
);

export const ProposalBook = ({ color = '#186cb2', size = 18 }: { color?: string; size?: number }) => (
    <svg className="shrink-0" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 5.5A2.5 2.5 0 0 1 6.5 3H20v17H6.5A2.5 2.5 0 0 0 4 22Z" />
        <path d="M4 5.5v16" />
        <path d="m9 11 2 2 4-4" />
    </svg>
);

export const ProposalView = ({ color = '#186cb2', size = 18 }: { color?: string; size?: number }) => (
    <svg className="shrink-0" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z" />
        <circle cx="12" cy="12" r="2.5" />
    </svg>
);

export const ProposalDownload = ({ color = '#186cb2', size = 18 }: { color?: string; size?: number }) => (
    <svg className="shrink-0" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 3v12" />
        <path d="m7 10 5 5 5-5" />
        <path d="M4 20h16" />
    </svg>
);

export const ProposalDocument = ({ color = '#186cb2', size = 18 }: { color?: string; size?: number }) => (
    <svg className="shrink-0" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M6 2.5h8l4 4V21H6Z" />
        <path d="M14 2.5V7h4" />
        <path d="M9 11h6" />
        <path d="M9 15h6" />
    </svg>
);

export const ProposalDocumentCheck = ({ color = '#186cb2', size = 18 }: { color?: string; size?: number }) => (
    <svg className="shrink-0" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M6 2.5h8l4 4V13" />
        <path d="M14 2.5V7h4" />
        <path d="M9 11h3" />
        <path d="M9 15h2" />
        <path d="m14 17 2 2 4-4" />
    </svg>
);

export const ProposalDocumentSearch = ({ color = '#186cb2', size = 18 }: { color?: string; size?: number }) => (
    <svg className="shrink-0" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M6 2.5h8l4 4V13" />
        <path d="M14 2.5V7h4" />
        <path d="M9 11h5" />
        <path d="M9 14h3" />
        <circle cx="15.5" cy="17.5" r="3" />
        <path d="m18 20 2 2" />
    </svg>
);

export const CreateProposalIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4">
        <path strokeLinecap="round" strokeLinejoin="round" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M14 2v6h6M8 13h8M8 17h5" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M16 17h4M18 15v4" />
    </svg>
);

export const ProposalStatusIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4">
        <path strokeLinecap="round" strokeLinejoin="round" d="M8 3h8a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 8h6M9 12h6M9 16h4" />
    </svg>
);

export const ExtensionIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6l4 2" />
        <circle cx="12" cy="12" r="9" />
    </svg>
);

export const ProposalsIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4">
        <path strokeLinecap="round" strokeLinejoin="round" d="M7 3h10a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 7h6M9 11h6M9 15h4" />
    </svg>
);

export const ComplianceIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 3 20 6v5c0 5-3.4 8.7-8 10-4.6-1.3-8-5-8-10V6l8-3Z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="m9 12 2 2 4-4" />
    </svg>
);

export const ComputationIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4">
        <rect x="5" y="2.5" width="14" height="19" rx="2" />
        <path strokeLinecap="round" d="M8 6h8M8 10h2M14 10h2M8 14h2M14 14h2M8 18h8" />
    </svg>
);

export const AmendmentIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4">
        <path strokeLinecap="round" strokeLinejoin="round" d="M4 20h4l10.5-10.5a2.12 2.12 0 0 0-3-3L5 17v3Z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="m13.5 7.5 3 3" />
    </svg>
);

export const NewAccountIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4">
        <circle cx="9" cy="8" r="3" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 20a6 6 0 0 1 12 0M18 8v6M15 11h6" />
    </svg>
);

export const UserManagementIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4">
        <circle cx="9" cy="8" r="3" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 20a6 6 0 0 1 12 0M17 11a3 3 0 1 0 0-6M18 14a5 5 0 0 1 3 4" />
    </svg>
);

export const ConfigurationIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 8.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="m19.4 15 .1.1a2 2 0 0 1-2.8 2.8l-.1-.1a2 2 0 0 0-3.4 1.4V19a2 2 0 0 1-4 0v-.2A2 2 0 0 0 5.8 17l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a2 2 0 0 0-1.4-3.4H1.5a2 2 0 0 1 0-4h.2A2 2 0 0 0 3 3.4l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1A2 2 0 0 0 9.2 1.5V1.3a2 2 0 0 1 4 0v.2A2 2 0 0 0 16.6 3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a2 2 0 0 0 1.4 3.4h.2a2 2 0 0 1 0 4h-.2a2 2 0 0 0-1.4 1.8Z" />
    </svg>
);

export const AccountIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4">
        <circle cx="12" cy="8" r="3.5" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 21a7.5 7.5 0 0 1 15 0" />
    </svg>
);

export const PolicyReviewIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4">
        <path strokeLinecap="round" strokeLinejoin="round" d="M7 3h7l4 4v14H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M14 3v5h5" />
        <circle cx="11" cy="14" r="2.5" />
        <path strokeLinecap="round" strokeLinejoin="round" d="m13 16 2.5 2.5" />
    </svg>
);

export const ApprovalIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4">
        <path strokeLinecap="round" strokeLinejoin="round" d="M7 3h7l4 4v14H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M14 3v5h5" />
        <path strokeLinecap="round" strokeLinejoin="round" d="m9 15 2 2 4-4" />
    </svg>
);

export const TeamApprovalIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4">
        <circle cx="9" cy="8" r="3" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 20a6 6 0 0 1 12 0" />
        <circle cx="17" cy="9" r="2.5" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M17 14a5 5 0 0 1 4 4" />
        <path strokeLinecap="round" strokeLinejoin="round" d="m15.5 15.5 1.5 1.5 3-3" />
    </svg>
);

export const MyTeamIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4">
        <path strokeLinecap="round" strokeLinejoin="round" d="M16 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="10" cy="7" r="4" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M20 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
);

interface IconProps {
    width?: number;
    height?: number;
    className?: string;
}

export const UserIcon = ({ width = 24, height = 24, className = '' }: IconProps) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} >
        <path d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z" stroke="currentColor" strokeWidth="1.8" />
        <path d="M3.5 21C3.5 16.8579 7.30558 13.5 12 13.5C16.6944 13.5 20.5 16.8579 20.5 21" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
);

export const MailIcon = ({ width = 24, height = 24, className = '' }: IconProps) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} >
        <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="1.8" />
        <path d="M3.5 7L12 13L20.5 7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const PhoneIcon = ({ width = 24, height = 24, className = '' }: IconProps) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} >
        <path d="M7.5 3H5.8C4.806 3 4 3.806 4 4.8C4 13.194 10.806 20 19.2 20C20.194 20 21 19.194 21 18.2V16.5L16.8 14.8L14.7 16.9C11.6 15.5 9.5 13.4 8.1 10.3L10.2 8.2L8.5 4C8.3 3.4 7.9 3 7.5 3Z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const BriefcaseIcon = ({ width = 24, height = 24, className = '' }: IconProps) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} >
        <rect x="3" y="7" width="18" height="13" rx="2" stroke="currentColor" strokeWidth="1.8" />
        <path d="M8 7V5.5C8 4.67157 8.67157 4 9.5 4H14.5C15.3284 4 16 4.67157 16 5.5V7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        <path d="M3 12H21" stroke="currentColor" strokeWidth="1.8" />
        <path d="M10 12V14H14V12" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    </svg>
);

export const ShieldIcon = ({ width = 24, height = 24, className = '' }: IconProps) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} >
        <path d="M12 3L20 6V11.5C20 16.5 16.8 20 12 21C7.2 20 4 16.5 4 11.5V6L12 3Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
        <path d="M8.5 12L10.8 14.3L15.5 9.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const BuildingIcon = ({ width = 24, height = 24, className = '' }: IconProps) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} >
        <path d="M4 21V4C4 3.44772 4.44772 3 5 3H15C15.5523 3 16 3.44772 16 4V21" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
        <path d="M16 9H19C19.5523 9 20 9.44772 20 10V21" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
        <path d="M2 21H22" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        <path d="M8 7H10M8 11H10M8 15H10M12 7H14M12 11H14M12 15H14" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
);

export const LocationIcon = ({ width = 24, height = 24, className = '' }: IconProps) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} >
        <path d="M20 10C20 15 12 21 12 21C12 21 4 15 4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
        <circle cx="12" cy="10" r="2.5" stroke="currentColor" strokeWidth="1.8" />
    </svg>
);

export const BadgeIcon = ({ width = 24, height = 24, className = '' }: IconProps) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} >
        <rect x="4" y="5" width="16" height="15" rx="2" stroke="currentColor" strokeWidth="1.8" />
        <circle cx="9" cy="11" r="2" stroke="currentColor" strokeWidth="1.6" />
        <path d="M6.5 16C7.2 14.7 8.1 14 9 14C9.9 14 10.8 14.7 11.5 16" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
        <path d="M14 10H17M14 13H17M14 16H17" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
);

export const IdCardIcon = ({ width = 24, height = 24, className = '' }: IconProps) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} >
        <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" strokeWidth="1.8" />
        <circle cx="8" cy="11" r="2" stroke="currentColor" strokeWidth="1.6" />
        <path d="M5.5 16C6.2 14.7 7.1 14 8 14C8.9 14 9.8 14.7 10.5 16" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
        <path d="M13.5 10H18M13.5 13H18M13.5 16H16" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
);

export const EditIconSVG = ({ size = 16, color = "currentColor" }: SpinnerProps) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 20H8L19.5 8.5C20.3284 7.67157 20.3284 6.32843 19.5 5.5C18.6716 4.67157 17.3284 4.67157 16.5 5.5L5 17V20Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14.5 7.5L18.5 11.5" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const CloseIconSVG = ({ size = 16, color = "currentColor" }: SpinnerProps) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 6L18 18M18 6L6 18" stroke={color} strokeWidth="2" strokeLinecap="round" />
    </svg>
);

export const SaveIconSVG = ({ size = 16, color = "currentColor" }: SpinnerProps) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 4H16L19 7V20H5V4Z" stroke={color} strokeWidth="2" strokeLinejoin="round" />
        <path d="M8 4V10H16V4" stroke={color} strokeWidth="2" strokeLinejoin="round" />
        <path d="M8 20V14H16V20" stroke={color} strokeWidth="2" strokeLinejoin="round" />
    </svg>
);

export const PolicyInformationIconSVG = ({ size = 16, color = "currentColor", className }: SpinnerProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} >
        <path d="M6 3.5h9l3 3V20.5H6z" />
        <path d="M15 3.5v3h3" />
        <path d="M9 11h6" />
        <path d="M9 14.5h6" />
        <path d="M9 18h3" />
    </svg>
);

export const PolicyScheduleIconSVG = ({ size = 16, color = "currentColor", className }: SpinnerProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} >
        <rect x="3.5" y="5" width="17" height="15.5" rx="2" />
        <path d="M7.5 3.5v3" />
        <path d="M16.5 3.5v3" />
        <path d="M3.5 9h17" />
        <path d="M7.5 12.5h.01" />
        <path d="M12 12.5h.01" />
        <path d="M16.5 12.5h.01" />
        <path d="M7.5 16h.01" />
        <path d="M12 16h.01" />
    </svg>
);

export const UnderwritingIconSVG = ({ size = 16, color = "currentColor", className }: SpinnerProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} >
        <path d="M12 3.5 19 6v5.5c0 4.5-2.8 7.5-7 9-4.2-1.5-7-4.5-7-9V6z" />
        <path d="m8.5 12 2.3 2.3 4.7-4.7" />
    </svg>
);

export const TurnAroundTimeIconSVG = ({ size = 16, color = "currentColor", className }: SpinnerProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} >
        <circle cx="12" cy="12" r="8.5" />
        <path d="M12 7.5v5l3.5 2" />
    </svg>
);

export const SigningAddressIconSVG = ({ size = 16, color = "currentColor", className }: SpinnerProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className={className} >
        <path d="M12 20.5s6-5.2 6-10a6 6 0 0 0-12 0c0 4.8 6 10 6 10Z" />
        <circle cx="12" cy="10.5" r="2" />
        <path d="M5 20.5h14" />
    </svg>
);

export const TransferOwnershipIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="h-4 w-4">
        <circle cx="9" cy="7" r="3" />
        <path d="M3.5 19a5.5 5.5 0 0 1 11 0" />
        <path d="M16 8h5m-2-2 2 2-2 2" />
        <path d="M21 16h-5m2-2-2 2 2 2" />
    </svg>
);

export const RequestIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="h-4 w-4">
        <path d="M13 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V10z" />
        <path d="M13 3v7h7" />
        <path d="M12 13v6m-3-3h6" />
    </svg>
);

export const GeneralChats = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="h-4 w-4">
        <path strokeLinecap="round" strokeLinejoin="round" d="M7 8h10M7 12h6m-8 8 3.5-3H17a4 4 0 0 0 4-4V7a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v9a4 4 0 0 0 2 3.46Z" />
    </svg>
);

export const CreateRenewalIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="h-4 w-4">
        <path d="M13 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5" />
        <path d="M13 3v7h7" />
        <path d="M15 14h6" />
        <path d="M18 11v6" />
    </svg>
);

export const ProposalIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="h-4 w-4">
        <path d="M13 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V10z" />
        <path d="M13 3v7h7" />
        <path d="M8 14h8" />
        <path d="M8 18h5" />
    </svg>
);